// extracted by mini-css-extract-plugin
module.exports = {"certificates-description":"style_certificates-description__RkD3i"};